import { render } from "./NotificationFooterPane.vue?vue&type=template&id=5795c6e0&scoped=true&ts=true"
import script from "./NotificationFooterPane.vue?vue&type=script&lang=ts"
export * from "./NotificationFooterPane.vue?vue&type=script&lang=ts"

import "./NotificationFooterPane.vue?vue&type=style&index=0&id=5795c6e0&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5795c6e0"]])

export default __exports__